import { ref } from '@vue/composition-api'
import useCampaigns from '../core/hooks/dashboard/useCampaigns'
import store from '../store'

const getLastCampaign = () => {
    const uid = store.state.user.uid
    const {data, getData} = useCampaigns()
    const lastCampaignUrl = ref()
    getData('publish', uid)
        .then(() => {
            if(!data.value.length) return
            lastCampaignUrl.value = `${window.location.origin}/campaigns/${data.value[0].id}?utm_source=banner&utm_medium=${data.value[0].title}&utm_campaign=prm`
        })
    
    return {
        lastCampaignUrl
    }
} 

export default getLastCampaign